import{__exports as e}from"../../../../../../_virtual/encodeLabelhash.js";Object.defineProperty(e,"__esModule",{value:!0}),e.encodeLabelhash=void 0,e.encodeLabelhash=function(e){return`[${e.slice(2)}]`};export{e as default};
